import { render, staticRenderFns } from "./CategoriesInfo.vue?vue&type=template&id=11a73f80"
import script from "./CategoriesInfo.vue?vue&type=script&lang=js"
export * from "./CategoriesInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports